import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'common-chips',
  imports: [],
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
})
export class ChipsComponent {
  @Input() options: any[];
  @Input() isCommodity: boolean;
  @Input() groupedOption = false;
  @Output() removeOption = new EventEmitter();

  onRemoveOptions(event: Event, option: any) {
    event.preventDefault();
    event.stopPropagation();
    this.removeOption.emit(option);
  }

  get isAnySelected(): boolean {
    if (this.groupedOption) {
      // Check for selected options inside the groups
      return this.options?.some((group) =>
        group.options?.some((option) => option?.selected),
      );
    } else {
      // Check for selected options in flat structure
      return this.options?.some((option) => option?.selected);
    }
  }

  getSelectedOptions(): any[] {
    if (this.groupedOption) {
      // Flatten the selected options from grouped structure
      return this.options?.reduce(
        (selected, group) => [
          ...selected,
          ...group.options?.filter((option) => option.selected),
        ],
        [],
      );
    } else {
      // Return the selected options from flat structure
      return this.options?.filter((option) => option.selected);
    }
  }
}
